import { Countries } from './types';
interface SelectorOptions {
  name: string;
  value: string;
}
type CountrySelectors = { [key in Countries]: SelectorOptions[] | null };

export const ON_CHANGE = 'ON_CHANGE';
export const FETCH_BUSSINESS_TYPES_SUCCESS = 'FETCH_BUSSINESS_TYPES_SUCCESS';
export const FETCH_BUSINESS_TYPES_ERROR = 'FETCH_BUSINESS_TYPES_ERROR';

export const ON_VALIDATION_ERRORS = 'ON_VALIDATION_ERRORS';

export const ON_SUBMIT = 'ON_SUBMIT';
export const ON_SUBMIT_FAILURE = 'ON_SUBMIT_FAILURE';
export const ON_SUBMIT_SUCCESS = 'ON_SUBMIT_SUCCESS';

export const BASE_ROUTE = '/merchant/signup';
export const FETCH_BUSINESS_TYPES_URL = '/merchant/inbound/api/pds';
export const LEAD_CREATION_URL = '/merchant/inbound/api/lead';
export const STATES: CountrySelectors = {
  CA: [
    {
      name: 'AB',
      value: 'Alberta (AB)',
    },
    {
      name: 'BC',
      value: 'British Columbia (BC)',
    },
    {
      name: 'MB',
      value: 'Manitoba (MB)',
    },
    {
      name: 'NB',
      value: 'New Brunswick (NB)',
    },
    {
      name: 'NL',
      value: 'Newfoundland and Labrador (NL)',
    },
    {
      name: 'NT',
      value: 'Northwest Territories (NT)',
    },
    {
      name: 'NS',
      value: 'Nova Scotia (NS)',
    },
    {
      name: 'NU',
      value: 'Nunavut (NU)',
    },
    {
      name: 'PE',
      value: 'Prince Edward Island (PE)',
    },
    {
      name: 'SK',
      value: 'Saskatchewan (SK)',
    },
    {
      name: 'ON',
      value: 'Ontario (ON)',
    },
    {
      name: 'QC',
      value: 'Quebec (QC)',
    },
    {
      name: 'YT',
      value: 'Yukon (YT)',
    },
  ],
  IE: [
    {
      name: 'Carlow',
      value: 'Carlow',
    },
    {
      name: 'Cavan',
      value: 'Cavan',
    },
    {
      name: 'Clare',
      value: 'Clare',
    },
    {
      name: 'Cork',
      value: 'Cork',
    },
    {
      name: 'Donegal',
      value: 'Donegal',
    },
    {
      name: 'Dublin',
      value: 'Dublin',
    },
    {
      name: 'Dun Laoghaire-Rathdown',
      value: 'Dun Laoghaire-Rathdown',
    },
    {
      name: 'Fingal',
      value: 'Fingal',
    },
    {
      name: 'Galway',
      value: 'Galway',
    },
    {
      name: 'Kerry',
      value: 'Kerry',
    },
    {
      name: 'Kildare',
      value: 'Kildare',
    },
    {
      name: 'Kilkenny',
      value: 'Kilkenny',
    },
    {
      name: 'Laois',
      value: 'Laois',
    },
    {
      name: 'Leitrim',
      value: 'Leitrim',
    },
    {
      name: 'Limerick',
      value: 'Limerick',
    },
    {
      name: 'Longford',
      value: 'Longford',
    },
    {
      name: 'Louth',
      value: 'Louth',
    },
    {
      name: 'Mayo',
      value: 'Mayo',
    },
    {
      name: 'Meath',
      value: 'Meath',
    },
    {
      name: 'Monaghan',
      value: 'Monaghan',
    },
    {
      name: 'Offaly',
      value: 'Offaly',
    },
    {
      name: 'Roscommon',
      value: 'Roscommon',
    },
    {
      name: 'Sligo',
      value: 'Sligo',
    },
    {
      name: 'South Dublin',
      value: 'South Dublin',
    },
    {
      name: 'Tipperary',
      value: 'Tipperary',
    },
    {
      name: 'Waterford',
      value: 'Waterford',
    },
    {
      name: 'Westmeath',
      value: 'Westmeath',
    },
    {
      name: 'Wexford',
      value: 'Wexford',
    },
    {
      name: 'Wicklow',
      value: 'Wicklow',
    },
  ],
  NL: [
    {
      name: 'Drenthe',
      value: 'Drenthe',
    },
    {
      name: 'Flevoland',
      value: 'Flevoland',
    },
    {
      name: 'Friesland',
      value: 'Friesland',
    },
    {
      name: 'Gelderland',
      value: 'Gelderland',
    },
    {
      name: 'Groningen',
      value: 'Groningen',
    },
    {
      name: 'Limburg',
      value: 'Limburg',
    },
    {
      name: 'Noord-Brabant',
      value: 'Noord-Brabant',
    },
    {
      name: 'Noord-Holland',
      value: 'Noord-Holland',
    },
    {
      name: 'Overijssel',
      value: 'Overijssel',
    },
    {
      name: 'Utrecht',
      value: 'Utrecht',
    },
    {
      name: 'Zeeland',
      value: 'Zeeland',
    },
    {
      name: 'Zuid-Holland',
      value: 'Zuid-Holland',
    },
  ],
  IT: [
    {
      name: 'Agrigento',
      value: 'AG',
    },
    {
      name: 'Alessandria',
      value: 'AL',
    },
    {
      name: 'Ancona',
      value: 'AN',
    },
    {
      name: 'Aosta',
      value: 'AO',
    },
    {
      name: 'Arezzo',
      value: 'AR',
    },
    {
      name: 'Ascoli Piceno',
      value: 'AP',
    },
    {
      name: 'Asti',
      value: 'AT',
    },
    {
      name: 'Avellino',
      value: 'AV',
    },
    {
      name: 'Bari',
      value: 'BA',
    },
    {
      name: 'Barletta-Andria-Trani',
      value: 'BT',
    },
    {
      name: 'Belluno',
      value: 'BL',
    },
    {
      name: 'Benevento',
      value: 'BN',
    },
    {
      name: 'Bergamo',
      value: 'BG',
    },
    {
      name: 'Biella',
      value: 'BI',
    },
    {
      name: 'Bologna',
      value: 'BO',
    },
    {
      name: 'Brescia',
      value: 'BS',
    },
    {
      name: 'Brindisi',
      value: 'BR',
    },
    {
      name: 'Cagliari',
      value: 'CA',
    },
    {
      name: 'Caltanissetta',
      value: 'CL',
    },
    {
      name: 'Campobasso',
      value: 'CB',
    },
    {
      name: 'Carbonia-Iglesias',
      value: 'CI',
    },
    {
      name: 'Caserta',
      value: 'CE',
    },
    {
      name: 'Catania',
      value: 'CT',
    },
    {
      name: 'Catanzaro',
      value: 'CZ',
    },
    {
      name: 'Chieti',
      value: 'CH',
    },
    {
      name: 'Como',
      value: 'CO',
    },
    {
      name: 'Cosenza',
      value: 'CS',
    },
    {
      name: 'Cremona',
      value: 'CR',
    },
    {
      name: 'Crotone',
      value: 'KR',
    },
    {
      name: 'Cuneo',
      value: 'CN',
    },
    {
      name: 'Enna',
      value: 'EN',
    },
    {
      name: 'Fermo',
      value: 'FM',
    },
    {
      name: 'Ferrara',
      value: 'FE',
    },
    {
      name: 'Florence',
      value: 'FI',
    },
    {
      name: 'Foggia',
      value: 'FG',
    },
    {
      name: 'Forlì-Cesena',
      value: 'FC',
    },
    {
      name: 'Frosinone',
      value: 'FR',
    },
    {
      name: 'Genoa',
      value: 'GE',
    },
    {
      name: 'Gorizia',
      value: 'GO',
    },
    {
      name: 'Grosseto',
      value: 'GR',
    },
    {
      name: 'Imperia',
      value: 'IM',
    },
    {
      name: 'Isernia',
      value: 'IS',
    },
    {
      name: 'La Spezia',
      value: 'SP',
    },
    {
      name: "L'Aquila",
      value: 'AQ',
    },
    {
      name: 'Latina',
      value: 'LT',
    },
    {
      name: 'Lecce',
      value: 'LE',
    },
    {
      name: 'Lecco',
      value: 'LC',
    },
    {
      name: 'Livorno',
      value: 'LI',
    },
    {
      name: 'Lodi',
      value: 'LO',
    },
    {
      name: 'Lucca',
      value: 'LU',
    },
    {
      name: 'Macerata',
      value: 'MC',
    },
    {
      name: 'Mantua',
      value: 'MN',
    },
    {
      name: 'Massa and Carrara',
      value: 'MS',
    },
    {
      name: 'Matera',
      value: 'MT',
    },
    {
      name: 'Medio Campidano',
      value: 'VS',
    },
    {
      name: 'Messina',
      value: 'ME',
    },
    {
      name: 'Milan',
      value: 'MI',
    },
    {
      name: 'Modena',
      value: 'MO',
    },
    {
      name: 'Monza and Brianza',
      value: 'MB',
    },
    {
      name: 'Naples',
      value: 'NA',
    },
    {
      name: 'Novara',
      value: 'NO',
    },
    {
      name: 'Nuoro',
      value: 'NU',
    },
    {
      name: 'Ogliastra',
      value: 'OG',
    },
    {
      name: 'Olbia-Tempio',
      value: 'OT',
    },
    {
      name: 'Oristano',
      value: 'OR',
    },
    {
      name: 'Padua',
      value: 'PD',
    },
    {
      name: 'Palermo',
      value: 'PA',
    },
    {
      name: 'Parma',
      value: 'PR',
    },
    {
      name: 'Pavia',
      value: 'PV',
    },
    {
      name: 'Perugia',
      value: 'PG',
    },
    {
      name: 'Pesaro and Urbino',
      value: 'PU',
    },
    {
      name: 'Pescara',
      value: 'PE',
    },
    {
      name: 'Piacenza',
      value: 'PC',
    },
    {
      name: 'Pisa',
      value: 'PI',
    },
    {
      name: 'Pistoia',
      value: 'PT',
    },
    {
      name: 'Pordenone',
      value: 'PN',
    },
    {
      name: 'Potenza',
      value: 'PZ',
    },
    {
      name: 'Prato',
      value: 'PO',
    },
    {
      name: 'Ragusa',
      value: 'RG',
    },
    {
      name: 'Ravenna',
      value: 'RA',
    },
    {
      name: 'Reggio Calabria',
      value: 'RC',
    },
    {
      name: 'Reggio Emilia',
      value: 'RE',
    },
    {
      name: 'Rieti',
      value: 'RI',
    },
    {
      name: 'Rimini',
      value: 'RN',
    },
    {
      name: 'Rome',
      value: 'RM',
    },
    {
      name: 'Rovigo',
      value: 'RO',
    },
    {
      name: 'Salerno',
      value: 'SA',
    },
    {
      name: 'Sassari',
      value: 'SS',
    },
    {
      name: 'Savona',
      value: 'SV',
    },
    {
      name: 'Siena',
      value: 'SI',
    },
    {
      name: 'Sondrio',
      value: 'SO',
    },
    {
      name: 'South Tyrol',
      value: 'BZ',
    },
    {
      name: 'Syracuse',
      value: 'SR',
    },
    {
      name: 'Taranto',
      value: 'TA',
    },
    {
      name: 'Teramo',
      value: 'TE',
    },
    {
      name: 'Terni',
      value: 'TR',
    },
    {
      name: 'Trapani',
      value: 'TP',
    },
    {
      name: 'Trentino',
      value: 'TN',
    },
    {
      name: 'Treviso',
      value: 'TV',
    },
    {
      name: 'Trieste',
      value: 'TS',
    },
    {
      name: 'Turin',
      value: 'TO',
    },
    {
      name: 'Udine',
      value: 'UD',
    },
    {
      name: 'Varese',
      value: 'VA',
    },
    {
      name: 'Venice',
      value: 'VE',
    },
    {
      name: 'Verbano-Cusio-Ossola',
      value: 'VB',
    },
    {
      name: 'Vercelli',
      value: 'VC',
    },
    {
      name: 'Verona',
      value: 'VR',
    },
    {
      name: 'Vibo Valentia',
      value: 'VV',
    },
    {
      name: 'Vicenza',
      value: 'VI',
    },
    {
      name: 'Viterbo',
      value: 'VT',
    },
  ],
  US: [
    {
      name: 'AL',
      value: 'Alabama',
    },
    {
      name: 'AK',
      value: 'Alaska',
    },
    {
      name: 'AZ',
      value: 'Arizona',
    },
    {
      name: 'AR',
      value: 'Arkansas',
    },
    {
      name: 'CA',
      value: 'California',
    },
    {
      name: 'CO',
      value: 'Colorado',
    },
    {
      name: 'CT',
      value: 'Connecticut',
    },
    {
      name: 'DE',
      value: 'Delaware',
    },
    {
      name: 'DC',
      value: 'District of Columbia',
    },
    {
      name: 'FL',
      value: 'Florida',
    },
    {
      name: 'GA',
      value: 'Georgia',
    },
    {
      name: 'HI',
      value: 'Hawaii',
    },
    {
      name: 'ID',
      value: 'Idaho',
    },
    {
      name: 'IL',
      value: 'Illinois',
    },
    {
      name: 'IN',
      value: 'Indiana',
    },
    {
      name: 'IA',
      value: 'Iowa',
    },
    {
      name: 'KS',
      value: 'Kansas',
    },
    {
      name: 'KY',
      value: 'Kentucky',
    },
    {
      name: 'LA',
      value: 'Louisiana',
    },
    {
      name: 'ME',
      value: 'Maine',
    },
    {
      name: 'MD',
      value: 'Maryland',
    },
    {
      name: 'MA',
      value: 'Massachusetts',
    },
    {
      name: 'MI',
      value: 'Michigan',
    },
    {
      name: 'MN',
      value: 'Minnesota',
    },
    {
      name: 'MS',
      value: 'Mississippi',
    },
    {
      name: 'MO',
      value: 'Missouri',
    },
    {
      name: 'MT',
      value: 'Montana',
    },
    {
      name: 'NE',
      value: 'Nebraska',
    },
    {
      name: 'NV',
      value: 'Nevada',
    },
    {
      name: 'NH',
      value: 'New Hampshire',
    },
    {
      name: 'NJ',
      value: 'New Jersey',
    },
    {
      name: 'NM',
      value: 'New Mexico',
    },
    {
      name: 'NY',
      value: 'New York',
    },
    {
      name: 'NC',
      value: 'North Carolina',
    },
    {
      name: 'ND',
      value: 'North Dakota',
    },
    {
      name: 'OH',
      value: 'Ohio',
    },
    {
      name: 'OK',
      value: 'Oklahoma',
    },
    {
      name: 'OR',
      value: 'Oregon',
    },
    {
      name: 'PA',
      value: 'Pennsylvania',
    },
    {
      name: 'RI',
      value: 'Rhode Island',
    },
    {
      name: 'SC',
      value: 'South Carolina',
    },
    {
      name: 'SD',
      value: 'South Dakota',
    },
    {
      name: 'TN',
      value: 'Tennessee',
    },
    {
      name: 'TX',
      value: 'Texas',
    },
    {
      name: 'UT',
      value: 'Utah',
    },
    {
      name: 'VT',
      value: 'Vermont',
    },
    {
      name: 'VA',
      value: 'Virginia',
    },
    {
      name: 'WA',
      value: 'Washington',
    },
    {
      name: 'WV',
      value: 'West Virginia',
    },
    {
      name: 'WI',
      value: 'Wisconsin',
    },
    {
      name: 'WY',
      value: 'Wyoming',
    },
  ],
  FR: null,
  DE: null,
  BE: null,
  ES: null,
  PL: null,
  JP: null,
  AU: null,
  NZ: null,
  AE: null,
  GB: null,
};

export const COUNTRIES_PICKER: CountrySelectors = {
  US: [
    {
      name: 'United States',
      value: 'US',
    },
    {
      name: 'Canada',
      value: 'CA',
    },
  ],
  FR: null,
  DE: null,
  BE: null,
  ES: null,
  PL: null,
  JP: null,
  AU: null,
  NZ: null,
  AE: null,
  GB: null,
  IE: null,
  NL: null,
  IT: null,
  CA: null,
};

export const HIDE_PINCODE_COUNTRIES = ['IE'];
